export default __webpack_public_path__ + "static/media/pray.98514662.svg";